module.exports = __webpack_public_path__ + "static/media/PaletteIcon.d41b5767.svg";